import { useState, useEffect } from 'react';
import { getPlugins, getPluginById } from '../services/pluginService';

export const usePlugins = () => {
  const [plugins, setPlugins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPlugins = async () => {
      try {
        setLoading(true);
        const pluginsData = await getPlugins();
        setPlugins(pluginsData);
        setError(null);
      } catch (err) {
        setError(err.message);
        console.error('Error fetching plugins:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPlugins();
  }, []);

  const refetch = async () => {
    try {
      setLoading(true);
      const pluginsData = await getPlugins();
      setPlugins(pluginsData);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return { plugins, loading, error, refetch };
};

export const usePlugin = (pluginId) => {
  const [plugin, setPlugin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPlugin = async () => {
      if (!pluginId) return;
      
      try {
        setLoading(true);
        const pluginData = await getPluginById(pluginId);
        setPlugin(pluginData);
        setError(null);
      } catch (err) {
        setError(err.message);
        console.error('Error fetching plugin:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPlugin();
  }, [pluginId]);

  return { plugin, loading, error };
};